<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="showForm(null)"
          >新增成品油客户</el-button
        >
      </template>
      <el-form
        :model="searchForm"
        ref="formData"
        inline
        class="global-form-label-width account-form"
        label-width="100px"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input
            clearable
            v-model="searchForm.userName"
            placeholder="姓名"
          />
        </el-form-item>

        <el-form-item label="角色" prop="roleId">
          <el-select v-model="searchForm.roleId" clearable>
            <el-option
              :label="item.roleName"
              :value="item.roleId"
              v-for="(item, index) of roles"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            clearable
            v-model="searchForm.mobile"
            placeholder="手机号"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="登录账号" prop="loginId"></el-table-column>
        <el-table-column
          min-width="120"
          label="姓名"
          prop="userName"
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="手机号"
          prop="mobile"
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="角色"
          prop="roleName"
        ></el-table-column>
        <el-table-column width="250" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template v-if="row.isAdmin === '0'">
              <el-button
                type="text"
                @click="
                  $router.push('/system/cpyUser/edit?userId=' + row.userId)
                "
                >编辑</el-button
              >
              <el-button type="text" @click="resetPassword(row.userId)"
                >重置密码</el-button
              >
              <el-button
                type="text"
                v-if="row.userId !== '2021020603'"
                @click="deleteRow(row.userId)"
                class="del-btn"
                >删除</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AccountManage',
  data () {
    return {
      activeType: '1',
      tableData: [],
      roles: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: null,
        mobile: '',
        roleId: '',
        deptId: ''
      },
      dialogVisible: false
    }
  },
  created () {
    this.loadData()
    this.loadRoles()
  },
  computed: {
    deptData () {
      return this.$store.state.deptList
    }
  },
  methods: {
    loadRoles () {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    closeCascader () {
      this.$refs.cascader.dropDownVisible = false
    },
    loadData () {
      const params = {
        page: this.page,
        mobile: this.searchForm.mobile,
        userType: '3',
        userName: this.searchForm.userName,
        roleId: this.searchForm.roleId
      }
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        params: params
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.formData.resetFields()
    },
    showForm () {
      this.$router.push('/system/cpyUser/add')
    },
    resetPassword (userId) {
      this.$confirm('重置后的密码为用户手机号后六位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.resetPassword, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    },
    deleteRow (userId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.eliminateIparkUser, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }
</style>
<style lang='scss'>
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
